export default __webpack_public_path__ + "static/home_logo-d9a0270161e561cd95a1c46ba42e60c0.png";